function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Component } from "react";
import LazyLoad from "react-lazy-load";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { VOD_MODAL } from "@common/constants";
import { HAS_ACCESS, KEY_ENTER, KEY_SPACE, ORDER_SUBSCRIPTIONS_ENABLED, ROUTE_ORDER_SUBSCRIPTIONS, ROUTE_SEARCH, SEARCH_TYPE_ACTIVE, TRANSITION_TIMEOUT, VOD, VOD_CATEGORIES_DEFAULT_OPTIONS, VOD_CATEGORIES_OPTIONS } from "@config/constants";
import { deleteAuthToken, getFullUserDetails, openModal, openPromotions, removeUserDetails } from "@common/actions";
import ShowCategories from "@common/components/show/ShowCategories";
import ShowImage from "@common/components/show/ShowImage";
import { getDateAndTimeWithLive } from "@common/services/helpers";
import { isEmpty, isNil } from "lodash";
var VodCard = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(VodCard, Component);
    var _super = _create_super(VodCard);
    function VodCard(props) {
        _class_call_check(this, VodCard);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showTabIndex: "0",
            isFocused: false,
            shouldLinkBeColorful: false
        };
        _this.type = props.type || null;
        _this.photos = props.photos;
        _this.show = null;
        _this.goToSearch = _this.goToSearch.bind(_assert_this_initialized(_this));
        _this.handleFocusChange = _this.handleFocusChange.bind(_assert_this_initialized(_this));
        _this.handleMouseEnter = _this.handleMouseEnter.bind(_assert_this_initialized(_this));
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_assert_this_initialized(_this));
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_assert_this_initialized(_this));
        _this.openModal = _this.openModal.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(VodCard, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.videoPlayerWrapper && this.props.videoPlayerWrapper.contains(this.show)) {
                    this.setState({
                        showTabIndex: "-1"
                    });
                }
            }
        },
        {
            /**
     * Navigate to search page with
     * query param set to the show's title
     */ key: "goToSearch",
            value: function goToSearch() {
                var _this_props = this.props, history = _this_props.history, show = _this_props.show, closePlayer = _this_props.closePlayer, videoPlayer = _this_props.videoPlayer, logo = _this_props.logo;
                if (logo && logo.access !== HAS_ACCESS && ORDER_SUBSCRIPTIONS_ENABLED) {
                    this.props.history.push(ROUTE_ORDER_SUBSCRIPTIONS);
                } else {
                    var quotedTitle = '"'.concat(show.title, '"');
                    var query = "?query=".concat(encodeURIComponent(quotedTitle), "&type=").concat(SEARCH_TYPE_ACTIVE);
                    var prevQuery = history.location.search;
                    if (prevQuery === query) {
                        return;
                    }
                    history && history.push("".concat(ROUTE_SEARCH).concat(query));
                    if (videoPlayer.isOpen) {
                        closePlayer();
                    }
                }
            }
        },
        {
            /**
     * Changes the element's focus
     * @param isFocused {Boolean}
     */ key: "handleFocusChange",
            value: function handleFocusChange(isFocused) {
                if (isFocused !== this.state.isFocused) {
                    this.setState({
                        isFocused: isFocused
                    });
                }
            }
        },
        {
            key: "handleMouseEnter",
            value: function handleMouseEnter() {
                this.setState({
                    shouldLinkBeColorful: true
                });
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave() {
                this.setState({
                    shouldLinkBeColorful: false
                });
            }
        },
        {
            key: "handleHeaderClick",
            value: function handleHeaderClick() {
                var _this_props = this.props, history = _this_props.history, show = _this_props.show;
                history.push("/channel/".concat(show.chanId));
            }
        },
        {
            key: "openModal",
            value: function openModal(event, show) {
                event.stopPropagation();
                this.props.openModal(VOD_MODAL, {
                    show: show
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                if (nextProps.isOpenEpgsList !== this.props.isOpenEpgsList) {
                    if (nextProps.isOpenEpgsList) {
                        this.setState({
                            showTabIndex: "0"
                        });
                        setTimeout(function() {
                            if (_this.show && _this.show.classList.contains("slick-current")) {
                                _this.show.focus();
                            }
                        }, TRANSITION_TIMEOUT);
                    } else {
                        this.setState({
                            showTabIndex: "-1"
                        });
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props_photos_find, _VOD_CATEGORIES_OPTIONS_show_majorId, _VOD_CATEGORIES_OPTIONS_show_majorId1;
                var _this_state = this.state, showTabIndex = _this_state.showTabIndex, isFocused = _this_state.isFocused, shouldLinkBeColorful = _this_state.shouldLinkBeColorful;
                var _this_props = this.props, className = _this_props.className, containerEvents = _this_props.containerEvents, i18n = _this_props.i18n, isInPlayer = _this_props.isInPlayer, logo = _this_props.logo, show = _this_props.show, showLiveLabel = _this_props.showLiveLabel, tabIndex = _this_props.tabIndex, isCardWithoutHeader = _this_props.isCardWithoutHeader, _this_props_shouldLazyLoad = _this_props.shouldLazyLoad, shouldLazyLoad = _this_props_shouldLazyLoad === void 0 ? false : _this_props_shouldLazyLoad, photos = _this_props.photos;
                var tabIndexDynamic = this.show && !this.show.classList.contains("slick-active") ? showTabIndex : "-1";
                var containerProps = _object_spread({}, containerEvents);
                var showTitleProps = {};
                if (containerEvents) {
                    containerProps.className = "pointer";
                    containerProps.tabIndex = isInPlayer ? tabIndexDynamic : "0";
                    containerProps.onFocus = function() {
                        return _this.handleFocusChange(true);
                    };
                    containerProps.onBlur = function() {
                        return _this.handleFocusChange(false);
                    };
                } else {
                    showTitleProps.onKeyDown = this.handleKeyDown;
                    showTitleProps.tabIndex = isInPlayer ? tabIndexDynamic : "0";
                }
                var cardClasses = className || "";
                cardClasses += " show show-bigger vod-card";
                cardClasses += isCardWithoutHeader ? " shorter" : "";
                var showImageComponent = /*#__PURE__*/ _jsx("img", {
                    draggable: "false",
                    src: this.props.photos && ((_this_props_photos_find = this.props.photos.find(function(e) {
                        return e.type === "poster";
                    })) === null || _this_props_photos_find === void 0 ? void 0 : _this_props_photos_find.url),
                    // alt={altText}
                    onError: this.handleImageLoadError,
                    className: "zoom",
                    style: {
                        display: "block",
                        width: "100%",
                        minHeight: 414
                    }
                });
                var showThumbnail = shouldLazyLoad ? /*#__PURE__*/ _jsx(LazyLoad, {
                    className: "show-thumbnail",
                    offset: 1000,
                    debounce: false,
                    children: showImageComponent
                }) : showImageComponent;
                var showTitleOption = !isEmpty(VOD_CATEGORIES_OPTIONS) && !isNil((_VOD_CATEGORIES_OPTIONS_show_majorId = VOD_CATEGORIES_OPTIONS[show.majorId]) === null || _VOD_CATEGORIES_OPTIONS_show_majorId === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_show_majorId.showTitle) ? (_VOD_CATEGORIES_OPTIONS_show_majorId1 = VOD_CATEGORIES_OPTIONS[show.majorId]) === null || _VOD_CATEGORIES_OPTIONS_show_majorId1 === void 0 ? void 0 : _VOD_CATEGORIES_OPTIONS_show_majorId1.showTitle : VOD_CATEGORIES_DEFAULT_OPTIONS.showTitle;
                return /*#__PURE__*/ _jsx("div", {
                    ref: function(node) {
                        return _this.show = node;
                    },
                    tabIndex: tabIndex,
                    onClick: function(event) {
                        return _this.openModal(event, show);
                    },
                    className: cardClasses,
                    children: show ? /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, containerProps), {
                            children: [
                                showThumbnail,
                                showTitleOption && /*#__PURE__*/ _jsxs("div", {
                                    className: "show-info",
                                    style: {
                                        paddingBottom: "15px"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                                            className: "show-title",
                                            "data-tip": "".concat(i18n.common.searchChannel, ": ").concat(show.title),
                                            "data-for": isInPlayer ? "player-slider-tooltip" : "show-slider-tooltip"
                                        }, showTitleProps), {
                                            children: show.title
                                        })),
                                        /*#__PURE__*/ _jsx(ShowCategories, {
                                            minorCategories: show["minor_categories"] || show.categories,
                                            majorCategory: show["major_category"]
                                        })
                                    ]
                                })
                            ]
                        }))
                    }) : null
                });
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
                // Returning `false` hugely improves the sliding experience
                // on mobile browsers. Before this fix the `render` method
                // was being called on every swipe. As long as this component
                // won't be updated dynamically this behaviour is OK.
                return nextState.showTabIndex !== this.state.showTabIndex || nextState.isFocused !== this.state.isFocused || nextState.shouldLinkBeColorful !== this.state.shouldLinkBeColorful || nextProps.currentWatchedEpg !== this.props.currentWatchedEpg || nextProps.logo !== this.props.logo;
            }
        }
    ]);
    return VodCard;
}(Component);
var mapStateToProps = function(param) {
    var videoPlayer = param.videoPlayer;
    return {
        videoPlayer: videoPlayer
    };
};
export default withRouter(connect(mapStateToProps, {
    openModal: openModal
})(VodCard));
